// Layout constants for the timeline. Pixel scale is "comfortable" on desktop:
// roughly one decade per ~1200px at default zoom.

export const PIXELS_PER_MONTH = 14;

// Tighter vertical sizing so 10 position lanes + 4 sections fit a normal
// viewport. ITEM_HEIGHT - 2 is the visible pill height; pill rx = (ITEM_HEIGHT - 2) / 2.
export const LANE_HEIGHT = 26;
export const LANE_GAP = 4;
export const SECTION_GAP = 18;
export const AXIS_HEIGHT = 50;
export const ITEM_HEIGHT = 20;
export const TIMELINE_PADDING_X = 200;

// Initial scroll anchor — January 2024 lands at the left edge of the viewport.
export const INITIAL_SCROLL_ANCHOR = "2024-01";

// Subtle Y-parallax: as scrollLeft decreases (panning back in time), the
// timeline group drifts upward. Tuned to be perceptible but not nauseating.
export const PARALLAX_FACTOR = 0.025;

// Section labels along the left margin
export const SECTION_LABEL_WIDTH = 140;
